module.exports = __webpack_public_path__ + "static/media/thumb_fallback.8bf47196.png";